import { TertiaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import Minus24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Minus24PxOutlined";
import Plus24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Plus24PxOutlined";
import styles from "./showMore.module.scss";
import classNames from "classnames";
import { booleanObj, showMessage } from "../../types";

type ShowButtonProps = {
  group: string;
  isShowingMore: booleanObj;
  setIsShowingMore: React.Dispatch<React.SetStateAction<booleanObj>>;
  showLessmessage: showMessage;
  showMoreMessage: showMessage;
  canShowMore: booleanObj;
};

export function ShowMore({
  group,
  isShowingMore,
  setIsShowingMore,
  showLessmessage,
  showMoreMessage,
  canShowMore,
}: ShowButtonProps) {
  const showMoreButtonTextClasses = classNames(
    styles["showMoreButtonText"],
    styles["joyfully-bold"],
  );

  if (!canShowMore[group]) {
    return null;
  }

  return (
    <div className={styles.showMoreContainer}>
      <TertiaryButton
        small={true}
        aria-expanded={isShowingMore[group]}
        onClick={() => {
          setIsShowingMore((prevState) => ({
            ...prevState,
            [group]: !isShowingMore[group],
          }));
        }}
        data-testid="sizeShowMore"
        IconComponent={() =>
          isShowingMore[group] ? <Minus24PxOutlined /> : <Plus24PxOutlined />
        }
        iconPositionRight
        className={styles.showMoreButton}
      >
        <span className={showMoreButtonTextClasses}>
          Show{" "}
          {isShowingMore[group]
            ? showLessmessage[group]
            : showMoreMessage[group]}{" "}
        </span>
      </TertiaryButton>
    </div>
  );
}
